<template>
  <mdb-container>
    <mdb-col v-if="showSpinner">
      <Spinner />
    </mdb-col>
    <mdb-row>
      <AssetStateForm @asset-state-created="onAssetStateCreated" />
    </mdb-row>

    <mdb-row>
      <AssetStateList :assetStates="assetStates" />
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from "@/api";
import Spinner from "@/components/Spinner";
import AssetStateForm from "@/components/AssetStateForm";
import AssetStateList from "@/components/AssetStateList";
import { mdbRow, mdbCol, mdbContainer } from "mdbvue";

export default {
  name: "AssetStatesConfig",
  components: {
    mdbRow,
    mdbCol,
    mdbContainer,
    Spinner,
    AssetStateForm,
    AssetStateList,
  },
  data() {
    return {
      assetStates: [],
      isLoading: true,
    };
  },

  computed: {
    showSpinner() {
      return this.isLoading;
    },
  },
  created() {
    this.isLoading = false;
    this.getAssetStateList();
    this.isLoading = false;
  },
  methods: {
    onAssetStateCreated() {
      this.getAssetStateList();
    },

    getAssetStateList() {
      api
        .getAllAssetStates()
        .then((response) => {
          this.assetStates.splice(0, this.assetStates.length, ...response.data);
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>

<style scoped lang="scss"></style>
